var heading_default = {
  "fontElementMap": "lvRuj",
  "elementSpacing": "_4W66L",
  "headerOne": "v4Wgl _4W66L",
  "headerTwo": "fJwKY _4W66L",
  "headerThree": "_3MNzt _4W66L",
  "headerFour": "lSCFd _4W66L",
  "headerFive": "oSeNl _4W66L",
  "headerSix": "_95aGO _4W66L",
  "child": "_0Z0K-"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
